<div class="filter-modal-container">
  <div class="header-container">
    <h2 mat-dialog-title>Filters</h2>
    <button mat-icon-button mat-dialog-close tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="content-container">
    <div mat-dialog-content>
      <div *ngFor="let filterType of filterTypes">
        <mat-form-field>
          <mat-label>Select {{ filterType.replace('_', ' ') }}</mat-label>

          <mat-select multiple [(ngModel)]="selectedFilters[filterType]">
            <mat-option *ngFor="let option of filterOptions[filterType]" [value]="option">
              {{ option }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-select-trigger>
          <mat-chip-listbox>
            <mat-chip
              *ngFor="let item of selectedFilters[filterType]"
              [removable]="true"
              (removed)="removeFilter(filterType, item)">
              {{ item }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-listbox>
        </mat-select-trigger>
      </div>
    </div>
    <mat-divider></mat-divider>

    <mat-dialog-actions>
      <button mat-stroked-button (click)="onClearAll()">Clear All</button>
      <button mat-flat-button (click)="onApply()">Apply Filters</button>
    </mat-dialog-actions>
  </div>
</div>
